<template>
    <v-form>
        <div class="az-form-content">
            <v-container fluid grid-list-xl>
                <detalhe-documentos-fornecedor-dados-gerais
                    v-if="lotesCarregado"
                    :lotes="lotes"
                    :fornecedores="fornecedores"
                    :documentos="documentos"
                    @buscarFornecedores="buscarFornecedores"
                    @buscarDocumentosFornecedor="buscarDocumentosFornecedor"
                />
            </v-container>
        </div>
    </v-form>
</template>

<script>
import {actionTypes} from '@/commons/constants'
import {mapActions} from 'vuex'
import DetalheDocumentosFornecedorDadosGerais from './components/dados-gerais/DetalheDocumentosFornecedorDadosGerais'

export default {
    name: 'ConsultasDetalheDocumentosFornecedor',
    components: {DetalheDocumentosFornecedorDadosGerais},
    data() {
        return {
            lotesCarregado: false,
            lotes: [],
            fornecedores: [],
            documentos: []
        }
    },
    async mounted() {
        await this.buscarLotes()
        this.lotesCarregado = true
    },
    methods: {
        async buscarDocumentosFornecedor(loteSelecionado, fornecedorSelecionado) {
            if (loteSelecionado && fornecedorSelecionado) {
                const payload = { idProcesso: this.$route.params.id, idLote: loteSelecionado, idFornecedor: fornecedorSelecionado}
                this.documentos = await this.buscarDocumentosFornecedoresUsiga(payload)
            }
        },
        async buscarLotes() {
            this.lotes = await this.buscarLotesPregaoUsiga(this.$route.params.id)
        },
        async buscarFornecedores(loteSelecionado) {
            const payload = { idProcesso: this.$route.params.id, idLote: loteSelecionado }
            const resposta = await this.buscarFornecedoresLegado(payload)
            this.fornecedores = resposta.fornecedores
        },
        ...mapActions([
            actionTypes.BUSCAR_LOTES_PREGAO_USIGA,
            actionTypes.BUSCAR_FORNECEDORES_LEGADO,
            actionTypes.BUSCAR_DOCUMENTOS_FORNECEDORES_USIGA
        ])
    }
}
</script>
